import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect from 'carbon-react/lib/components/select/simple-select';

import { OrganisationDSDisplayStatus } from '@futrli/views/operations/workspaces/types';

interface StatusFilterProps {
  onChange: (value: string) => void;
  selectedValue: string;
}

export const StatusFilter = ({ onChange, selectedValue }: StatusFilterProps) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const options = useMemo(
    () => [
      {
        value: 'all',
        label: intl.formatMessage({ id: 'predict.filters.status.all_statuses', defaultMessage: 'All statuses' })
      },
      {
        value: OrganisationDSDisplayStatus.SYNCED,
        label: intl.formatMessage({ id: 'common.synced', defaultMessage: 'Synced' })
      },
      {
        value: OrganisationDSDisplayStatus.SYNCING,
        label: intl.formatMessage({ id: 'common.syncing', defaultMessage: 'Syncing' })
      },
      {
        value: OrganisationDSDisplayStatus.CONNECTING,
        label: intl.formatMessage({ id: 'common.connecting', defaultMessage: 'Connecting' })
      },
      {
        value: OrganisationDSDisplayStatus.PENDING_SETUP,
        label: intl.formatMessage({ id: 'common.pending_setup', defaultMessage: 'Pending setup' })
      },
      {
        value: OrganisationDSDisplayStatus.SYNC_ERROR,
        label: intl.formatMessage({ id: 'common.sync_error', defaultMessage: 'Sync error' })
      },
      {
        value: OrganisationDSDisplayStatus.NOT_CONNECTED,
        label: intl.formatMessage({ id: 'common.not_connected', defaultMessage: 'Not connected' })
      }
    ],
    [intl]
  );

  return (
    <Box width={250}>
      <SimpleSelect
        label={intl.formatMessage({
          id: 'common.status',
          defaultMessage: 'Status'
        })}
        value={selectedValue}
        onChange={handleChange}
      >
        {options.map(option => (
          <Option key={option.value} value={option.value} text={option.label}>
            {option.label}
          </Option>
        ))}
      </SimpleSelect>
    </Box>
  );
};
